/**
 * Glossary JS
 */
const glossaryLetters = document.querySelectorAll('#js-glossary [data-index]');

if (glossaryLetters.length) {

  // Intersection Observer
  let observer = new IntersectionObserver(function (observables) {
    for (const observable of observables) {
      const index = observable.target.dataset.index*1;
      if (observable.isIntersecting) {
        glossaryLetters[index].classList.add('is-current');
      } else {
        glossaryLetters[index].classList.remove('is-current');
      }
    }
  }, {
    rootMargin: "-120px 0px"
  });

  // On observe nos éléments
  let items = document.querySelectorAll('.js-glossary-section');
  for (const item of items) {
    observer.observe(item);
  }
}
